// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-me {
  --about-me-padding: var(--about-me-padding-mobile);
  --about-me-description-padding: var(--about-me-description-padding-mobile);

  --icon-link-list-gap: var(--social-icons-gap);
  --icon-link-size: var(--social-icons-size);

  padding: var(--about-me-padding);
}

.about-me__title {
  font-family: var(--h2-font);
  font-size: var(--h2-fontsize);
  text-align: center;
  font-weight: bold;
}

.about-me__description {
  padding: var(--about-me-description-padding);
  color: var(--col-txt-p);
}

.about-me__social-list {
  margin: 0 auto;
}

/* mobile, horizontal */
@media only screen and (max-height: 550px) and (orientation: landscape) {
  .about-me {
    --about-me-padding: var(--about-me-padding-mobile-landscape);

    display: flex;
    flex-direction: column;
  }

  .about-me__float-space {
    flex: 1;
  }

  .about-me__social-list {
    flex: 2;
    align-items: center;
  }
}

/* tablet or larger */

@media only screen and (min-width: 767px) and (min-height: 551px) {
  .about-me {
    --about-me-padding: var(--about-me-padding-tablet);
    --about-me-description-padding: var(--about-me-description-padding-tablet);

    --float-space-width: calc(50% + var(--page-delta-padding-tablet));
    --float-space-height: calc(
      var(--txt-lineheight) * (var(--h2-fontsize) + 4 * var(--txt-fontsize)) +
        var(--about-me-description-padding-top-tablet) +
        var(--about-me-padding-left-right-tablet)
    );

    box-shadow: var(--box-shadow);
    border: var(--box-border);
    border-radius: var(--box-radius);
  }

  .about-me__float-space {
    float: left;
    height: var(--float-space-height);
    width: var(--float-space-width);
  }
}

/* desktop or larger */
@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {
  .about-me {
    --about-me-padding: var(--about-me-padding-desktop);
    --about-me-description-padding: var(--about-me-description-padding-desktop);

    display: flex;
    flex-direction: column;
  }

  .about-me__title {
    text-align: left;
  }

  .about-me__social-list {
    flex: 1;
    align-items: center;
    margin: 0 0 0 auto;
  }

  .about-me__float-space {
    float: none;
    height: 0;
    width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/aboutMe.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,0EAA0E;;EAE1E,6CAA6C;EAC7C,0CAA0C;;EAE1C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,4DAA4D;;IAE5D,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;IACP,mBAAmB;EACrB;AACF;;AAEA,qBAAqB;;AAErB;EACE;IACE,kDAAkD;IAClD,0EAA0E;;IAE1E,iEAAiE;IACjE;;;;KAIC;;IAED,6BAA6B;IAC7B,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,iCAAiC;IACjC,+BAA+B;EACjC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mDAAmD;IACnD,2EAA2E;;IAE3E,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,QAAQ;EACV;AACF","sourcesContent":[".about-me {\r\n  --about-me-padding: var(--about-me-padding-mobile);\r\n  --about-me-description-padding: var(--about-me-description-padding-mobile);\r\n\r\n  --icon-link-list-gap: var(--social-icons-gap);\r\n  --icon-link-size: var(--social-icons-size);\r\n\r\n  padding: var(--about-me-padding);\r\n}\r\n\r\n.about-me__title {\r\n  font-family: var(--h2-font);\r\n  font-size: var(--h2-fontsize);\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.about-me__description {\r\n  padding: var(--about-me-description-padding);\r\n  color: var(--col-txt-p);\r\n}\r\n\r\n.about-me__social-list {\r\n  margin: 0 auto;\r\n}\r\n\r\n/* mobile, horizontal */\r\n@media only screen and (max-height: 550px) and (orientation: landscape) {\r\n  .about-me {\r\n    --about-me-padding: var(--about-me-padding-mobile-landscape);\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .about-me__float-space {\r\n    flex: 1;\r\n  }\r\n\r\n  .about-me__social-list {\r\n    flex: 2;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n/* tablet or larger */\r\n\r\n@media only screen and (min-width: 767px) and (min-height: 551px) {\r\n  .about-me {\r\n    --about-me-padding: var(--about-me-padding-tablet);\r\n    --about-me-description-padding: var(--about-me-description-padding-tablet);\r\n\r\n    --float-space-width: calc(50% + var(--page-delta-padding-tablet));\r\n    --float-space-height: calc(\r\n      var(--txt-lineheight) * (var(--h2-fontsize) + 4 * var(--txt-fontsize)) +\r\n        var(--about-me-description-padding-top-tablet) +\r\n        var(--about-me-padding-left-right-tablet)\r\n    );\r\n\r\n    box-shadow: var(--box-shadow);\r\n    border: var(--box-border);\r\n    border-radius: var(--box-radius);\r\n  }\r\n\r\n  .about-me__float-space {\r\n    float: left;\r\n    height: var(--float-space-height);\r\n    width: var(--float-space-width);\r\n  }\r\n}\r\n\r\n/* desktop or larger */\r\n@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {\r\n  .about-me {\r\n    --about-me-padding: var(--about-me-padding-desktop);\r\n    --about-me-description-padding: var(--about-me-description-padding-desktop);\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .about-me__title {\r\n    text-align: left;\r\n  }\r\n\r\n  .about-me__social-list {\r\n    flex: 1;\r\n    align-items: center;\r\n    margin: 0 0 0 auto;\r\n  }\r\n\r\n  .about-me__float-space {\r\n    float: none;\r\n    height: 0;\r\n    width: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
